import React from "react";

const Loader = () => {
    return (
        <div className="backdrop">
            <div class="loader"></div>
        </div>
    );
};

export default Loader;

